import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'environments/environment';

import { reducers } from './reducers';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: true,
      },
    }),
    !environment.production ? StoreDevtoolsModule.instrument({ connectInZone: true }) : [],
    [],
  ],
  providers: [],
})
export class CoreStoreModule {}
